import { createAsyncThunk, createSlice, PayloadAction } from "@reduxjs/toolkit";
import { GetCoachesList } from "../../../utilities/api/coaches/index";
import { messages } from "../../../utilities/Messages";

type ErrorMessageType = {
  message: string;
}

type CoachListType = {
  fullName: string;
  role: string;
  phone: string;
  email: string;
  aadharNumber: string;
  id: string;
};

const initialState = {
  AllCoachesData: [] as CoachListType[],
  errorMessage: {} as ErrorMessageType,
};

export const AllCoachesList = createAsyncThunk("CoachList/AllCoachesList", () =>
  GetCoachesList()
);

const CoachesListSlice = createSlice({
  name: "CoachesList",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder

      .addCase(
        AllCoachesList.fulfilled,
        (state, action: PayloadAction<any>) => {
          if (action.payload.statusCode === 200) {
            state.AllCoachesData = action.payload.data.rows.map(
              (item: any) => ({
                fullName: item.firstName + " " + item.lastName,
                role: item.userRole.role.displayName,
                phone: item.phone,
                email: item.email,
                aadharNumber: item.aadharNumber,
                id: item.id,
                isActive: item.isActive ? "Active" : "Inactive",
              })
            );
          }
        }
      )
      .addCase(AllCoachesList.rejected, (state, action) => {
        state.errorMessage = { message: messages.error.internal_server_error };
      });

  },
});

export default CoachesListSlice.reducer;
